;(function () {
    function InitializeCard() {
        /**
         * local template service
         * @private
         */
        var _this = this

        /**
         * global cart configuration
         * @type {Object}
         */
        this.config = {}

        /**
         * cart data service
         * @property cartDataService
         * @type {function}
         */
        this.cartDataService = new window.Creaton.CartDataService()

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            _this.config = window.Creaton.Cart.Configuration
            _this.checkIfCartShouldBeCleared()
            _this.initializeCart()
            _this.deactivateLinkOnCartCta()

            $(document).on('newResultsAppended', function () {
                // unbind all events so they won't be bound twice when binding events on all elements
                _this.config.$cartModalCta.unbind()
                _this.config.$cartModal.unbind()

                // Add the elements received by the latest ajax request to the configuration
                window.Creaton.cartConfigurationCtrl.refreshConfig()

                _this.deactivateLinkOnCartCta()

                _this.initializeCart()
            })
        }

        this.initializeCart = function () {
            if (_this.cartIsAvailable()) {
                _this.setCartItems()
                new window.Creaton.cartModalLoader()
                new window.Creaton.cartCtaObserver()
                new window.Creaton.cartFiller()
            }
        }

        /**
         * Deactivate linking to product page when clicking on the cart cta
         */
        this.deactivateLinkOnCartCta = function () {
            _this.config.$cartModalCta.bind('click', function (event) {
                event.preventDefault()
            })
        }

        /**
         * check is a cart cta available
         * @return {boolean}
         */
        this.cartIsAvailable = function () {
            return _this.config.$cartModalCta.length >= 1 || _this.config.$cartHeaderIcon.length >= 1
        }

        /**
         * fill temp cart object
         */
        this.setCartItems = function () {
            var cartItems = localStorage.getItem(_this.config.cart)
            if ($.isEmptyObject(JSON.parse(cartItems)) || cartItems === null) {
                _this.config.$cartHeaderIconCounter.append()
                _this.config.$cartHeaderIcon.removeClass('btn-with-counter')
            } else {
                _this.config.cartItems = JSON.parse(cartItems)
                _this.config.$cartHeaderIconCounter.empty()
                _this.config.$cartHeaderIcon.addClass('btn-with-counter')
                _this.config.$cartHeaderIconCounter.append(_this.cartDataService.getTotalAmountOfSamples())
            }
        }

        /**
         * Clear the cart if necessary
         */
        this.checkIfCartShouldBeCleared = function () {
            var $shouldEmptyCart = $('[data-empty-cart=1]')
            if ($shouldEmptyCart.length > 0) {
                _this.removeCart()
                var cartItems = localStorage.getItem(_this.config.cart)
                _this.config.cartItems = JSON.parse(cartItems)
            }
        }

        /**
         *  Remove the current cart from the storage
         * @return {undefined}
         */
        this.removeCart = function () {
            localStorage.removeItem(_this.config.cart)
        }

        _this.init()
    }
    // define the global scope

    if (!window.Creaton.InitializeCard) {
        window.Creaton.InitializeCard = {}
    }
    window.Creaton.InitializeCard.InitializeCard = InitializeCard
})()

$(document).ready(function () {
    // This needs always to be initialized to display the cart button in the header correctly
    new window.Creaton.InitializeCard.InitializeCard()
})
